import { ICommandBase } from "@Quest/cqrs";

export class CreateResourceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Resources.Commands.CreateResourceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Unit: string;
	ExpenseClassification: string;
	CostPerUnit: number;

	constructor(workspaceId: number, strategyId: string, resourceId: string, name: string, unit: string, expenseClassification: string, costPerUnit: number)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = resourceId;
		this.Name = name;
		this.Unit = unit;
		this.ExpenseClassification = expenseClassification;
		this.CostPerUnit = costPerUnit;
	}


	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.CreateResourceCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateResourceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Unit: string;
	ExpenseClassification: string;

	constructor(workspaceId: number, strategyId: string, resourceId: string, name: string, unit: string, expenseClassification: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = resourceId;
		this.Name = name;
		this.Unit = unit;
		this.ExpenseClassification = expenseClassification;
	}


	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCommandV1, TCh.Domain.Quest'
	}
}

export class DeleteResourceCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Resources.Commands.DeleteResourceCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;

	constructor(workspaceId: number, strategyId: string, resourceId: string)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = resourceId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.DeleteResourceCommandV1, TCh.Domain.Quest'
	}
}

export class UpdateResourceCapacitiesCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCapacitiesCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	Entries: string[];

	constructor(workspaceId: number, strategyId: string, resourceId: string, entries: string[])
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = resourceId;
		this.Entries = entries;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Resources.Commands.UpdateResourceCapacitiesCommandV1, TCh.Domain.Quest'
	}
}